import React from "react";

// Style\\
import "../../assets/styles/sections/serviceSection.scss";
import ServiceGroup from "../parts/ServiceGroup";

const ServiceSection = () => {
  return (
    <section className="serviceSection">
      <div className="containers">
        <div className="service_items">
          <div className="title text-center">
            <h3>Our Service</h3>
            <p className="text-xl w-2/4">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Necessitatibus cumque harum nisi et minima rerum! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Necessitatibus cumque
              harum nisi et minima rerum!
            </p>
          </div>

          <div className="service_box">
            <ServiceGroup />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
